import { Stack } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../../common/styles/common.scss";
import { casesLinks } from "../../utils/Utilities";
const SideBar = ({ data }) => {
  const location = useLocation();
  return (
    <>
      <Stack className="cases-side-bar">
        {casesLinks(data).map((item) => (
          <Link
            key={item.id}
            to={item.to}
            className={`side-link${
              location.pathname === item.route ? " active" : ""
            }`}
          >
            {item.name}
            <div className={item.id === 3 ? "badge-red" : "badge"}>
              {item.list.length}
            </div>
          </Link>
        ))}
      </Stack>
    </>
  );
};

export default SideBar;
